// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit'
// api
import * as rms from './api/rms'

// thunks
export const fetchPublisherRevenue = createAsyncThunk('fetchPublisherRevenue', async requestData => {
  const response = await rms.postPublisherRevenueRequest(requestData)
  return response.data
})

export const fetchPrebidRevenue = createAsyncThunk('fetchPrebidRevenue', async requestData => {
  const response = await rms.postPrebidRevenueRequest(requestData)
  return response.data
})

export const fetchVideoPerformance = createAsyncThunk('fetchVideoPerformance', async requestData => {
  const response = await rms.postVideoPerformanceRequest(requestData)
  return response.data
})

export const fetchPageview = createAsyncThunk('fetchPageview', async requestData => {
  const response = await rms.postPageviewRequest(requestData)
  return response.data
})
/* -------------------------------------THUNKS FOR CSV-------------------------------------------------------------- */
export const fetchPublisherRevenueForCsv = createAsyncThunk('fetchPublisherRevenueForCsv', async requestData => {
  delete requestData.limit
  const response = await rms.postPublisherRevenueRequest(requestData)
  return response.data
})

export const fetchPageviewForCsv = createAsyncThunk('fetchPageviewForCsv', async requestData => {
  delete requestData.limit
  const response = await rms.postPageviewRequest(requestData)
  return response.data
})

export const fetchVideoPerformanceForCsv = createAsyncThunk('fetchVideoPerformanceForCsv', async requestData => {
  delete requestData.limit
  const response = await rms.postVideoPerformanceRequest(requestData)
  return response.data
})

export const fetchPrebidRevenueForCsv = createAsyncThunk('fetchPrebidRevenueForCsv', async requestData => {
  delete requestData.limit
  const response = await rms.postPrebidRevenueRequest(requestData)
  return response.data
})
